module.exports = __webpack_public_path__ + "static/img/card1.4951fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card1.png
// module id = pCY5
// module chunks = 0